import { Guid } from "typescript-guid";
import { watch } from "vue";
import { getToken, useCustomerIdRef } from "../api";
import { Api, type RequestParams } from "../flightpath-service-api-models";

const flightpathServiceHttpClient = new Api({
	baseApiParams: {
		secure: true,
		headers: useCustomerIdRef().value
			? { "X-Organization-Id": useCustomerIdRef().value }
			: {},
	},
	securityWorker: async () => {
		const headers: Record<string, string> = {
			Authorization: `Bearer ${await getToken()}`,
			"X-Request-Id": Guid.create().toString(),
		};

		return { headers };
	},
});

watch(
	useCustomerIdRef(),
	accountId => {
		if (!accountId) return;
		(
			flightpathServiceHttpClient as unknown as {
				baseApiParams: RequestParams;
			}
		).baseApiParams.headers = {
			"X-Organization-Id": accountId ?? "",
		};
	},
	{ immediate: true },
);

export const initFlightpathServiceClient = (defaultUrl: string) => {
	flightpathServiceHttpClient.baseUrl = `${defaultUrl}/cloud-api`;
};

export const useFlightpathServiceHttp = (): Api<unknown> =>
	flightpathServiceHttpClient as Api<unknown>;
